export default __webpack_public_path__ + "static/media/help.89f9cfab.svg";